import EnquiryContent from './Content';
import EnquiryProvider from './context';

const Enquiry: React.FunctionComponent = function () {
  return (
    <EnquiryProvider>
      <EnquiryContent />
    </EnquiryProvider>
  );
};

export default Enquiry;
